import {
    Modal, ModalHeader, ModalBody, Select, SelectOption, Button,
} from 'appkit-react';
import { Row, Col } from 'react-bootstrap';

const QuarterSelectModal = ({
    showPeriodSelectModal, selectedCrossReport, quarter, setQuarter, periodData,
    onCancel, onSaveQuarter,
}) => (
    <>
        <Modal
            className="action-modal-showcase"
            visible={showPeriodSelectModal}
            onCancel={() => onCancel()}
            style={{ width: '600px' }}
            backdropClosable={false}
        >
            <ModalHeader>
                <div className="a-modal-example-header">
                    <div className="modal-title-left">
                        <div className="modal-title">{`${selectedCrossReport.name} : Quarter Selection`}</div>
                    </div>
                </div>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={5}>
                        <div className="a-h6" style={{ marginBottom: '0.2rem' }}>Quarter </div>
                        <Select
                            onSelect={e => { setQuarter(e); }}
                            value={quarter}
                            name="quarter"
                            multiple
                        >
                            {
                                periodData.map(({ period, label, dataSource }) => (
                                    <SelectOption
                                        key={period}
                                        value={period}
                                        disabled={!dataSource}
                                    >
                                        {label}
                                    </SelectOption>
                                ))
                            }
                        </Select>
                    </Col>
                </Row>

                <div className="button-comp">
                    <Button kind="secondary" gray onClick={() => { onCancel(); }} size="lg"> Cancel </Button>
                    <Button kind="primary" onClick={onSaveQuarter} size="lg"> Save </Button>
                </div>
            </ModalBody>
        </Modal>
    </>
);

export default QuarterSelectModal;
